
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.851 11.01c.004-.073.125-.102.16-.039.17.3.458.741.785.942.327.2.85.257 1.194.272.073.003.102.124.038.16-.3.169-.74.457-.94.784-.201.327-.258.85-.273 1.194-.003.073-.124.102-.16.039-.169-.3-.457-.741-.784-.942-.327-.2-.85-.257-1.194-.271-.073-.004-.102-.125-.039-.16.3-.17.741-.458.942-.785.2-.327.257-.85.271-1.194zM12.328 10.343c-.005-.073-.133-.104-.171-.041-.115.188-.281.416-.465.529-.184.113-.462.157-.682.174-.073.006-.104.133-.041.172.188.115.415.28.529.464.112.184.157.462.174.682.006.073.133.104.172.041.115-.188.28-.415.464-.528.184-.113.462-.158.682-.175.073-.005.104-.133.041-.171-.188-.115-.415-.281-.528-.465-.113-.184-.158-.462-.175-.682zM9.803 2.668l-.162-.204c-.624-.789-.937-1.183-1.3-1.125-.363.058-.537.53-.884 1.475l-.09.244c-.099.269-.148.403-.243.501-.094.099-.224.15-.482.254l-.235.094-.166.066c-.8.32-1.202.503-1.254.856-.055.377.327.699 1.09 1.344l.197.167c.217.183.325.274.387.4.062.124.071.268.089.556l.016.262c.062 1.014.093 1.52.423 1.695.329.175.738-.098 1.557-.644l.212-.142c.233-.155.349-.232.482-.254.133-.021.268.016.537.091l.246.068c.948.263 1.422.394 1.68.125s.13-.76-.127-1.742l-.066-.254c-.073-.279-.11-.419-.09-.557.02-.138.095-.259.244-.5l.135-.22c.524-.851.786-1.277.616-1.618-.17-.34-.658-.371-1.635-.432l-.253-.016c-.278-.017-.417-.026-.538-.09-.12-.064-.209-.176-.386-.4zM5.89 8.884C4.465 9.58 3.28 10.683 2.832 12c-.501-3.138.194-5.165 1.31-6.425.096.197.221.36.333.487.234.264.568.547.908.834l.245.207.113.096.01.158.02.324c.027.436.053.863.119 1.203z","fill":"#fff"}})])
          )
        }
      }
    